// 表格图
<template>
  <div class="table-chart">
    <table
      border="1"
      cellspacing="0"
      style="
        width: 100%;
        table-layout: fixed;
        word-wrap: break-word;
        margin: 0 auto;
        text-align: center;
        border-collapse: collapse;
        font-size:12pt
      "
    >
      <thead>
        <tr>
          <th :style="showBtn?'text-align: left; padding-left: 5px; padding-right: 5px;width:200px':'text-align: left; padding-left: 5px; padding-right: 5px'">选项</th>
          <th style="text-align: left; padding-left: 5px; padding-right: 5px;width:120px">选项选择次数</th>
          <th :style="showBtn?'text-align: left; padding-left: 5px; padding-right: 5px;min-width:100px':'text-align: left; padding-left: 5px; padding-right: 5px;width:40px'">比例</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in taskItemData.surveyItems" :key="index">
          <td style="text-align: left; padding-left: 5px; padding-right: 5px;width:200px">{{item.text}}</td>
          <td style="text-align: left; padding-left: 5px; padding-right: 5px;width:60px">{{item.staffNum}}</td>
          <td style="text-align: left; padding-left: 5px; padding-right: 5px;min-width:100px">
            <div style="position:relative;width:200px;" v-if="showBtn">
              <div class="progress-bar" style="height:10px;width:200px;">
                <div style="width:190px;height: 10px;border-radius: 10px;background-color:#f5f5f5;"></div>
                <div :style="getProgressBar(item)"></div>
              </div>
              <span style="display: inline-block;position: absolute;right: -60px;top: -5px;">
                {{`${item.rate}%`}}
              </span>
            </div>
            <span v-else>{{`${item.rate}%`}}</span>
          </td>
        </tr>
        <tr>
          <td style="text-align: left; padding-left: 5px; padding-right: 5px">选项次数合计</td>
          <td style="text-align: left; padding-left: 5px; padding-right: 5px">{{taskItemData.surveyItemTotalNum}}</td>
          <td style="text-align: left; padding-left: 5px; padding-right: 5px"></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name:'TableChart',
  components: {},
  props: ['taskItemData','showBtn'],
  data() {
    return {
      tableData: [
        {
          type: '男',
          conut: '334',
          proportion: Number('55.55'),
        },
        {
          type: '女',
          conut: '134',
          proportion: Number('45.11'),
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    formatTooltip(val) {
      return Number(val);
    },
    getProgressBar(item) {
      return `width:${190*(item.rate/100)}px;height: 10px;border-radius: 10px;background-color:#409eff;position:absolute;top:0`
    }
  },
};
</script>

<style lang="less" scoped>
// 滑块样式
.slider-content {
  width: 80%;
  position: relative;
  .slider-content-tips {
    position: absolute;
    right: -55px;
    top: 0;
    transform: translateY(25%);
  }
}
.el-slider__runway.disabled .el-slider__bar {
  background-color: #409eff;
}
.el-slider__runway.disabled .el-slider__button {
  display: none;
}
.tdBg {
  border-bottom: none;
  border-right: none;
  padding: 0 6px;
}
</style>
